export default function isInViewport(node, parent = window) {
  var rect = node.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (parent.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (parent.innerWidth || document.documentElement.clientWidth)
  );
}
